import React, { Component } from 'react';

import AppealsMonitoring from './AppealsMonitoring/AppealsMonitoring';
import AnalyticaTelephonyi from './AnalyticaTelephonyi';
import AppealsCitizen from './AppealsCitizen';
import AppealsMap from './AppealsMap';
import CallControlIframe from './CallControlIframe';
import CategoryAnalytics from './CategoryAnalytics';
import NewAppeals from './NewAppeals';
import RegionAnalytics from './RegionAnalytics';

import { CaseMainTitle } from '../../components/newDesign/CaseMainTitle';
import { MainWrapper } from '../../components/newDesign/MainWrapper/MainWrapper';
import { RadioGroup } from '../../components/newDesign/RadioGroup';
import { logCaseVisit } from '../../services/api';

const NAME_COMP = {
  'Обращения граждан': <AppealsCitizen />,
  'Работа SENIM109': <NewAppeals />,
  'Мониторинг исполнения': <AppealsMonitoring />,
  'Аналитика категорий': <CategoryAnalytics />,
  'Аналитика регионов': <RegionAnalytics />,
  'Карта обращений': <AppealsMap />,
  'Аналитика телефонии': <AnalyticaTelephonyi />,
  'Контроль обращений': <CallControlIframe />,
};

const CASE_NAME_BY_SUBTAB = {
  // IQALA — всё, что вокруг работы с обращениями
  'Обращения граждан': 'IQALA',
  'Мониторинг исполнения': 'IQALA',
  'Аналитика категорий': 'IQALA',
  'Аналитика регионов': 'IQALA',
  'Карта обращений': 'IQALA',
  'Контроль обращений': 'IQALA',
  // IKOMEK — колл-центр SENIM109 и телефония
  'Работа SENIM109': 'IKOMEK',
  'Аналитика телефонии': 'IKOMEK',
};

class Social extends Component {
  constructor(props) {
    super(props);
    this.state = {
      radio: Object.keys(NAME_COMP)[0],
    };
    this.lastLoggedCaseName = null;
  }

  componentDidMount() {
    this.logCaseVisitForCurrentRadio();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.radio !== this.state.radio || prevProps.subtabs !== this.props.subtabs) {
      this.logCaseVisitForCurrentRadio();
    }
  }

  logCaseVisitForCurrentRadio = () => {
    const { subtabs } = this.props;
    const { radio } = this.state;

    const currentSubtab = Array.isArray(subtabs)
      ? subtabs.find((subtab) => subtab.name === radio)
      : null;

    const fromBackend = currentSubtab && currentSubtab.caseName;
    const fromLocalMap = CASE_NAME_BY_SUBTAB[radio];

    const caseName = fromBackend || fromLocalMap;

    if (caseName && caseName !== this.lastLoggedCaseName) {
      this.lastLoggedCaseName = caseName;
      logCaseVisit(caseName).catch(() => {});
    }
  };

  radioChange = (value) => {
    this.setState({
      radio: value.target.value,
    });
  };

  render() {
    const { subtabs } = this.props;
    return (
      <MainWrapper>
        <CaseMainTitle>Обращения граждан</CaseMainTitle>
        <RadioGroup
          onChange={this.radioChange}
          value={this.state.radio}
          list={subtabs.map((i) => ({
            key: i.name,
            value: i.name,
          }))}
        />
        {Object.keys(NAME_COMP).map((nav) => {
          if (nav === this.state.radio) return NAME_COMP[nav];
          else return null;
        })}
      </MainWrapper>
    );
  }
}

export default Social;
